/**
 * ShippingPolicy.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import EditablePage from './EditablePage';
import SEO from './SEO';
import { useLanguage } from '../context/LanguageContext';
import { getTranslatedPage } from '../i18n/pages';

export default function ShippingPolicy() {
  const { language } = useLanguage();
  const tr = getTranslatedPage('shipping-policy', language);
  return (
    <>
      <SEO 
        title={`${tr?.title || 'Shipping Policy'} | Cranford Publications`}
        description={tr?.description || 'Learn about our shipping rates and delivery times for Celtic music products. Free shipping within Canada on orders over $50.'}
        canonical="/shipping-policy"
        keywords="shipping policy, delivery, international shipping, free shipping Canada"
      />
      <EditablePage pageId="shipping-policy" pageTitle={tr?.title || 'Shipping Policy'} />
    </>
  );
} 